
LocaleImport.$inject = ['$scope', '__env', 'toastr', 'httpService', 'readCookie', '$q', '$http'];angular
	.module('app')
	.component('localeImportComponent', {
		templateUrl: 'modules/localization/components/localeImport/localeImport.html',
		controller: LocaleImport
	});

/**
 * Locale import export controller; imports and exports the locale values per section
 *
 * @class Locales
 * @param { service } $scope - The scope of the component.
 * @param { service } __env - The environment configuration. 
 * @param { service } toastr - The third party toaster service.
 * @param { service } httpService - The http service used to make asynchronous rest calls
 * @param { service } readCookie - reads cookie variables
 */
function LocaleImport($scope, __env, toastr, httpService, readCookie, $q, $http) {	 	

	$scope.uploadedFile = function(element) {
	    $scope.$apply(function($scope) {
	    	if (element.files.length > 0){
	    		$scope.fileRequired = false;
	    		$scope.csvFile = element.files[0];	    		
	    	}
	    });
	};

	$scope.importLocaleValues = function(){

		if($scope.fileRequired)
			return;
            
        $scope.validationClass = 'valid';

        var url = __env.apiBaseUrlLocalization + '/localevalues/import/' + $scope.selectedSectionId;
		var method = 'POST';
		
		var fdata = new FormData();
    	fdata.append('file', $scope.csvFile);
    	var fileName = $scope.csvFile.name;
    	
		httpService.multiPartDataCall(url, method, fdata)
		.then(function(response) {
				toastr.success('File imported: ' + fileName);
				console.log('File imported: ' + fileName);
			}).catch(function(e){
				toastr.error('Could not import the file.');				
		});
	};

	$scope.onRemove = function(e){		
		$scope.$apply(function($scope) {	    	
	    	$scope.fileRequired = true;
	    });
	};


	$scope.drpSectionOptions = {
	    // autoBind: false,
	    dataTextField: 'sectionCode',
	    dataValueField: 'sectionId',
	    valuePrimitive: true,
	    dataSource: new kendo.data.DataSource({
	        transport: {
	            read: function(options) {
	                options.success($scope.sections);
	            }
	        }
	    }),
	    optionLabel: { sectionCode: 'Select section...', sectionId: '' },
	    filter: 'startswith',	    
	};

	 /**
     * Sets up http request to get locale sections to use with grid edits.
     * On success, loads the sections array. Uses a promise to ensure
     * the sections are loaded before the grid.
     *
     * @function 
     */
    $scope.getSections = function() {

    	// wait for the types to resolve
    	return $q(function(resolve, reject) {

	    	var url = __env.apiBaseUrlLocalization + '/localesections';
	    	var type = 'get';
	    	var data = '';
			

	    	httpService.asyncCall(url, type, data)
				.then(function(response) {					
				    $scope.sections = response.data; 
				    $scope.drpSectionOptions.dataSource.read();
					resolve(true);					  
				}).catch(function(e){
					toastr.error('Did not get locale sections');
					reject(false);
				});	

		});  
    }; 
	
	/**
     * Runs first on page load and loads required data.
     *
     * @function      
     */   
    $scope.init = function(){   

    	$scope.selectedSectionId = null;
    	$scope.fileRequired = true;

    	var promises = [];    	
    	promises.push($scope.getSections());

    	//wait for all promises to finish before assigning kendo data source variable which will render the grid.
    	$q.all(promises).then(function(){

    	});

    };

	$scope.init();
	
}